<template>
  <vuex-table :fields="fields" table_store="pbx/contacts/table" class="table--content-middle">
    <template slot="last_name" slot-scope="{ item }">
      <router-link :to="{ name: 'pbx.contact.edit', params: { id: item.id } }">
        {{ item.last_name }} {{ item.first_name }}
      </router-link>
    </template>

    <template slot="contact_methods" slot-scope="{ formatted: value }">
      <contact-method-list-collapse :items="value" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-control type="trash" @click="remove_item(item)" />
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';

  import ContactMethodListCollapse from '@pbx/components/contact-methods/list-items-collapse';
  import { ContactModalService } from '@pbx/modals/ContactModalService';

  export default {
    components: { ContactMethodListCollapse },
    computed: {
      fields: function() {
        return [
          {
            key: 'last_name',
            label: this.$t('pbx.contact.table.field.full_name'),
            class: 'w-100',
            sortable: true
          },
          {
            key: 'contact_methods',
            label: this.$t('pbx.contact.table.field.contact_methods'),
            sortable: false,
            thStyle: {
              minWidth: '350px'
            }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/contacts/table', ['getAsyncData']),

      remove_item: function(item) {
        ContactModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
